/**
 * NOTE: V2 outcome statuses are included in both V2 outcome
 * REQUESTS and RESONSEs. However, the safest way to determine
 * if an outcome is actually completed is to coerce its `completed`
 * property to a boolean. This is a compatible way to check both V1
 * and V2 outcome objects.
 */
export default Object.freeze( {
	ALL: "ALL",
	COMPLETE: "COMPLETE",
	OUTSTANDING: "OUTSTANDING",
} );



// WEBPACK FOOTER //
// ./src/constants/OutcomeStatusV2.js